import styled from 'styled-components'
import Picker from 'emoji-picker-react'
import { IoMdSend } from 'react-icons/io'
import { BsEmojiSmileFill } from 'react-icons/bs'
import { useState } from 'react'
import useClickOutside from '../hooks/useClickOutside'

const ChatInput = ({ handleSendMsg }) => {
    const [msg, setMsg] = useState("");
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);
    const domNode = useClickOutside(() => setShowEmojiPicker(false))
    const toggleEmojiPicker = () => {
        setShowEmojiPicker(!showEmojiPicker);
    };

    const handleEmojiClick = (event, emojiObject) => {
        let message = msg;
        message += emojiObject.emoji;
        setMsg(message);
    };

    const sendChat = (event) => {
        event.preventDefault();
        if (msg.length > 0) {
            handleSendMsg(msg);
            setMsg("");
        }
    };
    return (
        <Wrapper>
            <div className="button-container">
                <div className="emoji">
                    <BsEmojiSmileFill onClick={toggleEmojiPicker} />
                    {
                        showEmojiPicker && <div ref={domNode}><Picker onEmojiClick={handleEmojiClick} /></div>
                    }
                </div>
            </div>
            <form className="input-container" onSubmit={sendChat}>
                <input value={msg} onChange={(e) => setMsg(e.target.value)} type="text" placeholder='Type your message here' />
                <button className="submit">
                    <IoMdSend />
                </button>
            </form>
        </Wrapper>
    )
}

const Wrapper = styled.div`
    display: grid;
    grid-template-columns:5% 95% ;
    align-items:center ;
    background-color:#080420 ;
    padding:0 2rem ;
    padding-bottom:0.3rem ;
    @media screen and (min-width: 720px) and (max-width: 1080px) {
        padding: 0 1rem;
        gap: 1rem;
    }
    .button-container{
        display: flex;
        align-items: center;
        color:#ffffff;
        gap:1rem;
        .emoji{
            position: relative;
            svg{
                font-size:1.5rem ;
                color: #ffff00c8;
                cursor: pointer;
            }
            .emoji-picker-react {
                position: absolute;
                top: -350px;
                background-color: #080420;
                box-shadow: 0 5px 10px #9a86f3;
                border-color: #9a86f3;
                .emoji-scroll-wrapper::-webkit-scrollbar {
                    background-color: #080420;
                    width: 5px;
                    &-thumb {
                        background-color: #9a86f3;
                    }
                }
                .emoji-categories {
                    button {
                        filter: contrast(0);
                    }
                }
                .emoji-search {
                    background-color: transparent;
                    border-color: #9a86f3;
                }
                .emoji-group:before {
                    background-color: #080420;
                }
            }
        }
    }
    .input-container {
            width: 100%;
            border-radius: 2rem;
            display: flex;
            align-items: center;
            gap: 2rem;
            background-color: #ffffff34;
            input {
            width: 90%;
            height: 60%;
            background-color: transparent;
            color: white;
            border: none;
            padding-left: 1rem;
            font-size: 1.2rem;
            &::selection {
                background-color: #9a86f3;
            }
            &:focus {
                outline: none;
            }
        }
        button {
            padding: 0.3rem 2rem;
            border-radius: 2rem;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #9a86f3;
            border: none;
            @media screen and (min-width: 720px) and (max-width: 1080px) {
                padding: 0.3rem 1rem;
                svg {
                font-size: 1rem;
                }
            }
            svg {
                font-size: 2rem;
                color: white;
            }
        }
    }
    @media (max-width: 720px){
        grid-template-columns:10% 90% ;
        padding:0 1rem ;
    }
`

export default ChatInput